/* global document */

import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import VueRouter from 'vue-router';
import store from './store';
import VueShave from 'vue-shave';
import VueBgSrc from 'vue-bg-src';

import { router } from './router';
import template from './app.vhtml';

sync(store, router);

Vue.use( VueRouter );
Vue.use( VueShave );
Vue.use( VueBgSrc, { mediaQueries: {
	md: '(min-width: 415px)',
	lg: '(min-width: 736px)',
	xl: '(min-width: 1000px)',
}});

export const App = new Vue({
	el: '#app',
	store,
	components: {
	},
	template: template,
	router: router,
	data: () => ({
		appLoaded: false,
	}),
	mounted() {
		const vm = this;
		setTimeout(() => {
			vm.appLoaded = true;
		}, 1000);
		this.$store.dispatch('appsData/initializeData');
	},
});



// WEBPACK FOOTER //
// ./assets/_js/app.js